(function () {
  function bindPackagingForm(form) {
    if (!form || form.dataset.packagingBound === 'true') return;
    form.dataset.packagingBound = 'true';

    var select = form.querySelector('[data-cart-packaging-select]');
    var qtyInput = form.querySelector('[data-cart-packaging-qty]');
    var addBtn = form.querySelector('[data-cart-packaging-add]');
    if (!select || !qtyInput || !addBtn) return;

    function syncAddButton() {
      addBtn.disabled = !select.value;
    }

    select.addEventListener('change', syncAddButton);
    syncAddButton();

    form.querySelectorAll('[data-packaging-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var delta = parseInt(btn.getAttribute('data-packaging-qty'), 10) || 0;
        var next = Math.max(1, Math.min(99, (parseInt(qtyInput.value, 10) || 1) + delta));
        qtyInput.value = next;
      });
    });

    qtyInput.addEventListener('change', function () {
      var val = parseInt(qtyInput.value, 10);
      if (!val || val < 1) qtyInput.value = 1;
      if (val > 99) qtyInput.value = 99;
    });
  }

  function initAll() {
    document.querySelectorAll('[data-cart-packaging-form]').forEach(bindPackagingForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
